import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=1635eecb&scoped=true&"
import script from "./Messaging.vue?vue&type=script&lang=ts&"
export * from "./Messaging.vue?vue&type=script&lang=ts&"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=1635eecb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635eecb",
  null
  
)

export default component.exports